var _defs, _rect, _line, _line2, _line3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack383({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 4.08,
    y: 1.82,
    width: 7.76,
    height: 4.79
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.47,
    y1: 8.3,
    x2: 8.47,
    y2: 12.82
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 9.66,
    y1: 8.3,
    x2: 9.66,
    y2: 12.82
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 10.85,
    y1: 8.3,
    x2: 10.85,
    y2: 12.82
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "12.67 10.56 12.67 0.61 3.73 0.61 3.23 0.61 2.73 0.61 2.73 3.82 3.23 3.82 3.23 15.39 12.17 15.39 12.67 15.39 13.17 15.39 13.17 10.56 12.67 10.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack383);
export default __webpack_public_path__ + "static/media/Symbol_pack_383.acc4aeee40b0aeb87d962d5124acb6cf.svg";
export { ForwardRef as ReactComponent };